import {
  SoftwareSelectionResolutionDto,
  THIRD_PARTY_SOFTWARE_SELECTION_REASONS,
} from 'src/app/models/device.model';

export function isThirdPartySoftwareSelection(
  resolution: SoftwareSelectionResolutionDto,
): boolean {
  return (
    !!resolution.selectionReason &&
    THIRD_PARTY_SOFTWARE_SELECTION_REASONS.has(resolution.selectionReason)
  );
}

export function isSoftwareSelectionDeviceDependent(
  resolution: SoftwareSelectionResolutionDto,
): boolean {
  return resolution.result === 'DEPENDS_ON_DEVICE';
}

export function isSoftwareSelectionResolutionError(
  resolution: SoftwareSelectionResolutionDto,
): boolean {
  if (isSoftwareSelectionDeviceDependent(resolution)) {
    return false;
  }
  return (
    resolution.result !== 'SUCCESS' ||
    isSpadokSoftwareVersionMissing(resolution)
  );
}

export function isSpadokSoftwareVersionMissing(
  resolution: SoftwareSelectionResolutionDto,
): boolean {
  return (
    !isThirdPartySoftwareSelection(resolution) &&
    !isSoftwareSelectionDeviceDependent(resolution) &&
    !resolution.spadokArtifact?.version
  );
}
